module.exports = __webpack_public_path__ + "static/media/car-fuel-blue.db204992.svg";